module.exports = __webpack_public_path__ + "img/22.df00ef90.jpg";